export { normalizeTextNodes } from './normalizeTextNodes';
export { NodeTextPosition } from './NodeTextPosition';

// tslint:disable no-magic-numbers
export const isElement = (node: Node): node is Element => node && node.nodeType === 1;
export const isText = (node: Node): node is Text => node && node.nodeType === 3;
// tslint:enable

// tslint:disable:no-shadowed-variable
// because parents is used as parameters name

//
// HTML Node Navigation
function precedingNode(node: Node) {
    if (node.previousSibling) {
        node = node.previousSibling;
        node = lastLeafNode(node);
        return node;
    }
    return node.parentNode;
}
function lastLeafNode(node: Node) {
    while (node.lastChild) {
        node = node.lastChild;
    }
    return node;
}
export function parents(start: Node, end: Node) {
    const res = [];
    for (let current = start && start.parentNode; current && current !== end; current = current.parentNode) {
        res.push(current);
    }
    return res;
}
export function closest(start: Node, end: Node, selector: string) {
    for (let current = start; current && current !== end; current = current.parentNode) {
        if (isElement(current) && current.matches(selector)) {
            return current;
        }
    }
}
export function followingNode(node: Node) {
    for (let current = node; current; current = current.parentNode) {
        if (current.nextSibling) {
            return current.nextSibling;
        }
    }
}
export function nextNode(node: Node) {
    if (!node) { return; }
    if (node.firstChild) {
        return node.firstChild;
    } else {
        return followingNode(node);
    }
}
export function prevNode(node: Node) {
    if (!node) { return; }
    if (node.previousSibling) {
        node = node.previousSibling;
        node = lastLeafNode(node);
        return node;
    } else {
        return precedingNode(node);
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/domop/index.tsx